export default __webpack_public_path__ + "2fc01d820f91968059dcfb7aca6dd096.png";